import { FormBuilderForm, Team } from '@/types';

export default function formRequiresUpgrade(form: FormBuilderForm, team: Team): boolean {
    if (form.is_core_template) {
        return false;
    }

    if (form.form_template_id === null) {
        return false;
    }

    if (team.usable_form_template_ids.includes(form.form_template_id) || team.usable_form_template_ids.includes(form.id)) {
        return false;
    }
    return true;
}
